import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getCompany =  async(an8) => {

    const url = `${ baseUrl }/company/details/${an8}`;
  
    const token = await authHeader();

    return axios.get(url,
      { headers: token }
      ).then(
        (response) => {
          return response.data;
    })
  };

  const getRetirement = async(an8) => {

    const url = `${ baseUrl }/retirement/details/${an8}`;
  
    const token = await authHeader();

    return axios.get(url,
      { headers: token }
    ).then(
        (response) => {
          return response.data;
    })
  };

  const getCement = async(an8) => {

    const url = `${ baseUrl }/cement/details/${an8}`;
  
    const token = await authHeader();

    return axios.get(url,
      { headers: token }
      ).then(
        (response) => {
          return response.data;
    })
  };

  const getDate = async() => {

    const url = `${ baseUrl }/date/details`;
  
    const token = await authHeader();

    return axios.get(url,
      { headers: token }
    ).then(
        (response) => {
          return response.data;
    })
  };

export default {
    getCompany,
    getCement,
    getRetirement,
    getDate
};